// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2tZXH","list":"PatternAutocomplete_list__2leOI"};